import type {ButtonProps} from '@yandex-delivery/blocks'

import {PaymentCardErrorCode} from '../../../../../api/payment'
import {usePassportUrl} from '../../../hooks/usePassportUrl'

const useMapCardErrorToButtonProps = (): Record<PaymentCardErrorCode, ButtonProps> => ({
  [PaymentCardErrorCode.UNAUTHORIZED]: {
    // @ts-expect-error TS2322: Type '"a"' is not assignable to type '"button"'.
    Component: 'a',
    href: usePassportUrl('/auth'),
    onPress: void 0,
  },
  [PaymentCardErrorCode.EMPTY_LOGIN]: {
    // @ts-expect-error TS2322: Type '"a"' is not assignable to type '"button"'.
    Component: 'a',
    href: usePassportUrl('/auth/complete'),
    onPress: void 0,
  },
  [PaymentCardErrorCode.EMPTY_PHONE]: {
    // @ts-expect-error TS2322: Type '"a"' is not assignable to type '"button"'.
    Component: 'a',
    href: usePassportUrl('/phoneconfirm'),
    onPress: void 0,
  },
})

export function usePaymentCardErrorButtonProps(paymentCardErrorCode?: PaymentCardErrorCode): ButtonProps | undefined {
  const mapCardErrorToButtonProps = useMapCardErrorToButtonProps()

  if (!paymentCardErrorCode) {
    return void 0
  }

  return mapCardErrorToButtonProps[paymentCardErrorCode]
}
